import { getPlayerData } from "core-integration/src/store/player/reducers";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import Alert from "../Alert";
import Box from "../Box";
import Home from "../Home";
import { Main, Wrapper } from "../Layout";

const SSOMissing = () => {
  const { t } = useTranslation();
  const player = useSelector(getPlayerData);
  const navigate = useNavigate();
  if (player && player.id) {
    navigate("/my-team");
  }

  return (
    <>
      <Wrapper>
        <Main isWide={true}>
          <Box>
            <Alert type="error">
              <h2>{t("ssoMissing.title", "Missing profile details")}</h2>
              <p>
                {t(
                  "ssoMissing.description",
                  "You are missing your given and family name in your profile. Please update your profile to play the game.",
                )}
              </p>
            </Alert>
          </Box>
        </Main>
      </Wrapper>
      <Home />
    </>
  );
};

export default SSOMissing;
